import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const NumeroInicialFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label
        text='NUMERO INICIAL'
        htmlFor='input-numeroInicial'
        xs={4}
        lg={5}
        alignRightAt='xs'
      />
      <Col xs={8} lg={7}>
        <Field name='numeroInicial'>
          {({ field }) => (
            <Form.InputNumber
              {...field}
              isInvalid={iTouched && iError}
              disabled={fIsSubmitting}
              id='input-numeroInicial'
            />
          )}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(NumeroInicialFormGroup)
